import React from "react"

const withQueryString = Component => {
  return class WithQueryStringComponent extends React.Component {
    state = {
      queryString: {},
    }

    UNSAFE_componentWillMount() {
      this.setState({
        queryString: this.queryStringToJson(),
      })
    }

    queryStringToJson() {
      if (
        typeof window === "undefined" ||
        typeof window.location === "undefined"
      )
        return {}
      if (window.location.search.length < 2) {
        return {}
      }

      const result = {}
      const variables = window.location.search.slice(1).split("&")
      variables.forEach(pair => {
        const variablePart = pair.split("=")
        result[variablePart[0]] = decodeURIComponent(variablePart[1] || "")
      })

      return JSON.parse(JSON.stringify(result))
    }

    render() {
      return <Component {...this.props} {...this.state} />
    }
  }
}

export default withQueryString
